module.exports = __webpack_public_path__ + "static/img/FYTT.9bcb2406.png";